















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import Loading from "../general/Loading.vue";

import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import MemberJson from "../../shared/MemberJson";
import { MemberStatus, MemberStatusNames } from "../../shared/MemberStatus";
import { MembershipType } from "../../shared/MembershipType";
import { MembershipRenewInterval } from "../../shared/MembershipRenewInterval";
import { MembershipTypeNames } from "../../shared/MembershipType";
import { MembershipRenewIntervalNames } from "../../shared/MembershipRenewInterval";

import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateMemberJsonManagement } from "../../shared/MemberJson";
import { validateMemberJsonManagementAdd } from "../../shared/MemberJson";
import { validateMemberJsonChilds } from "../../shared/MemberJson";
import MembershipTermJson from "../../shared/MembershipTermJson";
import { getNextMembershipTerm } from "../../shared/MembershipTermJson";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";

type keysForCachedTermPrices = {
  [key in keyof Pick<MembershipTermJson, "price">]: string;
};

export default Vue.extend({
  name: "MembersMemberDetails",
  components: {
    OverlayWindow,
    ExpandableView,
    Loading,
    InvoiceInfoDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    memberId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      Gender: Gender,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      MemberStatus: MemberStatus,
      MemberStatusNames: MemberStatusNames,
      MembershipType: MembershipType,
      MembershipRenewInterval: MembershipRenewInterval,
      MembershipTypeNames: MembershipTypeNames,
      MembershipRenewIntervalNames: MembershipRenewIntervalNames,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      selectedMemberId: null as number | null,
      cachedTermDates: [] as {
        beginDate: string;
        endDate: string;
      }[],
      cachedPrice: "0,00" as string,
      cachedTermPrices: [] as string[],
      memberDetails: null as MemberJson | null,
      useSepaMandate: false as boolean,
      //cachedCustomerChilds: [] as Pick<CustomerJson, "childFirstName" | "childLastName" | "childGender">[],
      cachedCustomerChilds: [] as CustomerJson[],
      cachedCustomerChildsBirthDates: [] as string[],
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<MemberJson> | null,
      validationChild: null as ValidationResult<{
        childs: CustomerJson[];
      }> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initMemberDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initMemberDetails() {
      this.selectedMemberId = this.memberId;
      this.loadMemberDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.setCachedCustomerChilds();
      this.setCachedCustomerChildsBirthDates();
      this.setCachedPrice();
      this.setCachedTermPrices();
      this.setCachedTermDates();

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadMemberDetails() {
      if (this.selectedMemberId != null) {
        if (this.restClient != null) {
          try {
            this.memberDetails = await this.restClient.getMember(this.selectedMemberId);

            if (this.memberDetails.sepaMandate != null) {
              this.useSepaMandate = true;
            }
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.memberDetails = this.getDefaultMemberData();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultMemberData() {
      return {
        ID: null,
        membershipType: MembershipType.normal,
        remarks: "",
        isCanceled: false,
        state: MemberStatus.requested,
        membershipTerms: [],
        customers: [this.getDefaultCustomer()],
        price: 0,
        renewInterval: MembershipRenewInterval.annual,
        sepaMandate: null,
        creationDateTime: new Date().toISOString(),
        linkedMailingRecipientId: null,
      };
    },

    getDefaultTerm(): MembershipTermJson {
      return {
        beginDate: "",
        endDate: "",
        price: 0,
        needsPaymentExport: true,
        invoiceInfos: null,
      };
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (this.memberDetails != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.memberDetails.customers[0].guardianFirstName,
          accountHolderLastName: this.memberDetails.customers[0].guardianLastName,
          addressStreet: this.memberDetails.customers[0].addressStreet,
          addressZip: this.memberDetails.customers[0].addressZip,
          addressCity: this.memberDetails.customers[0].addressCity,
          addressCountry: this.memberDetails.customers[0].addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "",
          IBAN: "",
          BIC: "",
        };
      }
    },

    //START set cached data

    setCachedCustomerChilds() {
      if (this.memberDetails != null) {
        let [family, ...childs] = this.memberDetails.customers;

        this.memberDetails.customers = [family];
        this.cachedCustomerChilds = childs;
      }
    },

    setCachedCustomerChildsBirthDates() {
      if (this.cachedCustomerChilds != null) {
        for (let i = 0; i < this.cachedCustomerChilds.length; i++) {
          if (this.cachedCustomerChilds[i].childBirthDate != "") {
            if (this.supportsDatePicker) {
              this.cachedCustomerChildsBirthDates[i] = this.cachedCustomerChilds[i].childBirthDate!;
            } else {
              let d = new Date(this.cachedCustomerChilds[i].childBirthDate!);

              if (d != null) {
                this.cachedCustomerChildsBirthDates[i] = DateFormatter.formatDateMedium(d);
              }
            }
          }
        }
      }
    },

    setCachedPrice() {
      if (this.memberDetails != null) {
        let price = this.memberDetails.price
          ?.toString()
          .padStart(3, "0")
          .replace(/(\d{2,2})$/g, ",$1")
          .replace("NaN", "");

        if (price !== undefined) {
          this.cachedPrice = price;
        }
      }

      /* if (this.memberDetails != null) {
            let k = this.cachedPrices
            let i: keyof typeof k

            for (i in this.cachedPrices) {
               let price = this.memberDetails[i]
                  ?.toString()
                  .padStart(3, "0")
                  .replace(/(\d{2,2})$/g, ",$1")
                  .replace("NaN", "")

               if (price !== undefined) {
                  this.cachedPrices[i] = price
               }
            }
         } */
    },

    setCachedTermPrices() {
      if (this.memberDetails != null) {
        for (let i = 0; i < this.memberDetails.membershipTerms.length; i++) {
          let price = this.memberDetails.membershipTerms[i].price
            ?.toString()
            .padStart(3, "0")
            .replace(/(\d{2,2})$/g, ",$1")
            .replace("NaN", "");

          if (price !== undefined) {
            this.cachedTermPrices[i] = price;
          }
        }
      }
    },

    setCachedTermDates() {
      if (this.memberDetails != null) {
        for (let i = 0; i < this.memberDetails.membershipTerms.length; i++) {
          this.cachedTermDates[i] = {
            beginDate: "",
            endDate: "",
          };

          if (this.memberDetails.membershipTerms[i].beginDate != "") {
            var d = new Date(this.memberDetails.membershipTerms[i].beginDate);

            if (this.supportsDatePicker) {
              this.cachedTermDates[i].beginDate = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedTermDates[i].beginDate = DateFormatter.formatDateMedium(d);
              }
            }
          }

          if (this.memberDetails.membershipTerms[i].endDate != "") {
            var d = new Date(this.memberDetails.membershipTerms[i].endDate);

            if (this.supportsDatePicker) {
              this.cachedTermDates[i].endDate = DateFormatter.formatISODate(d);
            } else {
              if (d != null) {
                this.cachedTermDates[i].endDate = DateFormatter.formatDateMedium(d);
              }
            }
          }
        }
      }
    },

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Mitglied hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Mitglied bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Mitglied";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
        this.loadMemberDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.hasChanges = false;
          this.loadMemberDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    childValidation(index: number, prop: any) {
      let key = "customerChild-" + index;

      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.validationChild = validateMemberJsonChilds(this.cachedCustomerChilds);

      this.$forceUpdate();
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.memberDetails != null) {
        this.validation = validateMemberJsonManagement(this.memberDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    formatCachedCustomerChildsBirthDates(customer: number) {
      if (this.cachedCustomerChilds != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedCustomerChildsBirthDates[customer];
        } else {
          if (this.cachedCustomerChildsBirthDates[customer].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedCustomerChildsBirthDates[customer]);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.cachedCustomerChilds[customer].childBirthDate = birthDate;
      }
    },

    addCachedChildsToMember() {
      if (this.memberDetails != null) {
        for (let i = 0; i < this.cachedCustomerChilds.length; i++) {
          this.cachedCustomerChilds[i].guardianFirstName = this.memberDetails.customers[i].guardianFirstName;
          this.cachedCustomerChilds[i].guardianLastName = this.memberDetails.customers[i].guardianLastName;
          this.cachedCustomerChilds[i].email = this.memberDetails.customers[i].email;
          this.cachedCustomerChilds[i].phone = this.memberDetails.customers[i].phone;
          this.cachedCustomerChilds[i].addressStreet = this.memberDetails.customers[i].addressStreet;
          this.cachedCustomerChilds[i].addressZip = this.memberDetails.customers[i].addressZip;
          this.cachedCustomerChilds[i].addressCity = this.memberDetails.customers[i].addressCity;
          this.cachedCustomerChilds[i].addressCountry = this.memberDetails.customers[i].addressCountry;

          this.memberDetails.customers.push(this.cachedCustomerChilds[i]);
        }
      }
    },

    formatCachedPriceAndSet() {
      if (this.memberDetails != null) {
        let price = this.cachedPrice.replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrice = price;

        this.memberDetails["price"] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    formatCachedTermPricesAndSet(index: number) {
      if (this.memberDetails != null && this.memberDetails.membershipTerms.length > 0) {
        let price = this.cachedTermPrices[index].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedTermPrices[index] = price;

        this.memberDetails.membershipTerms[index].price = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    formatCachedTermDatesAndSet(index: any) {
      if (index != null && this.memberDetails != null) {
        let k = this.cachedTermDates[index];
        let i: keyof typeof k;

        for (i in k) {
          var beginDate = "";
          var endDate = "";

          if (this.supportsDatePicker) {
            beginDate = this.cachedTermDates[index].beginDate;
            endDate = this.cachedTermDates[index].endDate;
          } else {
            //beginDate
            if (this.cachedTermDates[index].beginDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedTermDates[index].beginDate);

              if (d != null) {
                beginDate = DateFormatter.formatUSDate(d);
              }
            }

            //endDate
            if (this.cachedTermDates[index].endDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(this.cachedTermDates[index].endDate);

              if (d != null) {
                endDate = DateFormatter.formatUSDate(d);
              }
            }
          }

          this.memberDetails.membershipTerms[index].beginDate = beginDate;
          this.memberDetails.membershipTerms[index].endDate = endDate;
        }
      }
    },

    //END set input data (where data be cached)

    addChild() {
      this.cachedCustomerChilds.push(this.getDefaultCustomer());
    },

    deleteChild(index: number) {
      this.cachedCustomerChilds.splice(index, 1);
      this.cachedCustomerChildsBirthDates.splice(index, 1);

      delete this.toValidate["customerChild-" + index];
    },

    addTerm() {
      if (this.memberDetails != null) {
        /* let newTerm = this.getDefaultTerm()
            newTerm.price = this.memberDetails.price

            this.memberDetails.membershipTerms.push(newTerm)
            this.cachedTermDates.push({ beginDate: "", endDate: "" })
            this.cachedTermPrices.push(this.cachedPrice) */

        let newTerm = getNextMembershipTerm(
          this.memberDetails.membershipTerms,
          this.memberDetails.renewInterval,
          this.memberDetails.price || 0
        );
        this.memberDetails.membershipTerms.push(newTerm);
        /* this.cachedTermDates.push({ beginDate: "", endDate: "" })
            this.cachedTermPrices.push(this.cachedPrice) */
        this.setCachedTermPrices();
        this.setCachedTermDates();
      }
    },

    deleteTerm(index: number) {
      if (this.memberDetails != null) {
        this.memberDetails.membershipTerms.splice(index, 1);
        this.cachedTermDates.splice(index, 1);
        this.cachedTermPrices.splice(index, 1);

        delete this.toValidate["membershipTerms-" + index];
      }
    },

    toggleUseSepaMandate() {
      if (this.memberDetails != null) {
        if (this.useSepaMandate) {
          this.memberDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.memberDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    async addNewMember() {
      if (this.memberDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        let validationChildIsValid = true;

        if (this.cachedCustomerChilds.length > 0) {
          this.validationChild = validateMemberJsonChilds(this.cachedCustomerChilds);

          if (this.validationChild == null || this.validationChild.isValid != true) {
            validationChildIsValid = false;
          }
        }

        this.validation = validateMemberJsonManagementAdd(this.memberDetails);

        if (this.validation != null && this.validation.isValid == true && validationChildIsValid == true) {
          this.addCachedChildsToMember();

          try {
            this.memberDetails = await this.restClient.addMember(this.memberDetails);
            alert("Das Mitglied wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              if (this.memberDetails != null) {
                this.selectedMemberId = this.memberDetails.ID;
              }

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Das Mitglied konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveMemberDetails() {
      if (this.memberDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          let validationChildIsValid = true;

          if (this.cachedCustomerChilds.length > 0) {
            this.validationChild = validateMemberJsonChilds(this.cachedCustomerChilds);

            if (this.validationChild == null || this.validationChild.isValid != true) {
              validationChildIsValid = false;
            }
          }

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateMemberJsonManagement(this.memberDetails);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true && validationChildIsValid == true) {
            this.addCachedChildsToMember();

            if (this.restClient != null) {
              try {
                let updatedMemberDetails = await this.restClient.updateMember(this.memberDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteMember() {
      if (this.memberDetails != null) {
        let c = confirm("Wollen Sie dieses Mitglied wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteMember(this.memberDetails);
              this.closeDetails();
              alert("Das Mitglied wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendMemberConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        await this.saveMemberDetails();
      }

      if (this.selectedMemberId != null && this.restClient != null) {
        try {
          await this.restClient.confirmMember(this.selectedMemberId);
          alert("Es wurde eine Bestätigung an das neue Mitglied gesendet.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    memberDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    cachedCustomerChilds: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.memberDetails != null) {
          if (this.memberDetails.sepaMandate != null) {
            return this.memberDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.memberDetails != null) {
          if (this.memberDetails.sepaMandate != null) {
            this.memberDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
